import { ThemeOptions } from '@mui/material/styles';

import { darkThemeComponents } from './components';
import { darkThemePalette } from './palette';
import { darkThemeShadows } from './shadows';

export const darkThemeOptions: ThemeOptions = {
  components: darkThemeComponents,
  palette: darkThemePalette,
  shadows: darkThemeShadows,
};
